export interface DaisyChainTranslations {
  loadingAssessments: string;
  loading: string;
  dirtyPrompt: string;
}

export const daisyChainTranslationKeys: DaisyChainTranslations = {
  loadingAssessments: 'loadingAssessments',
  loading: 'loading',
  dirtyPrompt: 'dirtyPrompt',
};

export const daisyChainTranslationsEN: DaisyChainTranslations = {
  loadingAssessments: 'Loading Assessments...',
  loading: 'Loading...',
  dirtyPrompt: 'Are you sure you want to close the form? Incomplete assessments will be lost.',
};

export const daisyChainTranslationsES: DaisyChainTranslations = {
  loadingAssessments: 'Cargando evaluaciones...',
  loading: 'Cargando...',
  dirtyPrompt: '¿Está seguro de que desea cerrar el formulario? Las evaluaciones incompletas se perderán.',
};
